import { Route, Switch } from "react-router-dom";

import CustomizableSegmentPromoDurationPage from "../../workspace/kim/customizable-segment-promo-duration";
import DollarOffFreeShippingPromoPage from "../../workspace/kim/dollar-off-free-shipping-promo";
import InsiderSourcePage from "../../workspace/kim/insider-source";

export function ChanyeeKimRoutes() {
  return (
    <Switch>
      <Route
        path="/kim/customizable-segment-promo-duration"
        component={CustomizableSegmentPromoDurationPage}
      />
      <Route
        path="/kim/dollar-off-free-shipping-promo"
        component={DollarOffFreeShippingPromoPage}
      />
      <Route path="/kim/insider-source" component={InsiderSourcePage} />
    </Switch>
  );
}

export const slug = "kim";
